(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vava-dye-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__vavaDyeModalBound) return;
    window.__vavaDyeModalBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-dye-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-dye-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        return;
      }

      var closer = event.target.closest('[data-dye-close]');
      if (closer) {
        var parent = closer.closest('dialog');
        if (parent) parent.close();
        return;
      }

      if (event.target.classList && event.target.classList.contains('vava-dye-modal')) {
        event.target.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
